/**
 * Export Testing API — manual types and fetchers.
 * Not generated by Orval because these endpoints are new. Run `bun run codegen`
 * after the OpenAPI schema is regenerated to replace this file.
 */
import type { ExportDocTypeValue, ExportFontValue, ExportWorkflowStatusValue } from "@pages/ExportTesting/constants";
import type { ExportFrameworkValue } from "@pages/Templates/constants";

import { BASECAMP_API_BASE as BASE, apiFetch } from "./api-fetch";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface StartExportTestInput {
  report_id: string;
  doctype: ExportDocTypeValue;
  export_framework?: ExportFrameworkValue | null;
  template_url?: string | null;
  template_logo_url?: string | null;
  org_logo_url?: string | null;
  font?: ExportFontValue | null;
}

export interface StartExportTestOutput {
  workflow_id: string;
}

export interface ExportTestStatusOutput {
  status: ExportWorkflowStatusValue;
  download_url: string | null;
  error_message: string | null;
}

export interface RecentExportOverrides {
  exportFramework?: ExportFrameworkValue | null;
  templateUrl?: string | null;
  templateLogoUrl?: string | null;
  orgLogoUrl?: string | null;
  font?: ExportFontValue | null;
}

export interface RecentExport {
  workflow_id: string;
  status: ExportWorkflowStatusValue;
  started_at: string;
  closed_at: string | null;
  workflow_type: string;
  report_id: string | null;
  doctype: ExportDocTypeValue | null;
  overrides: RecentExportOverrides | null;
}

// ---------------------------------------------------------------------------
// API functions
// ---------------------------------------------------------------------------

export async function startExportTest(input: StartExportTestInput): Promise<StartExportTestOutput> {
  return apiFetch<StartExportTestOutput>(`${BASE}/exports/test`, {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function getExportTestStatus(workflow_id: string): Promise<ExportTestStatusOutput> {
  return apiFetch<ExportTestStatusOutput>(`${BASE}/exports/test-status/${workflow_id}`);
}

export async function listRecentExports(): Promise<RecentExport[]> {
  return apiFetch<RecentExport[]>(`${BASE}/exports/recent`);
}
